var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.certificate)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$wait.waiting(_vm._uid)),expression:"$wait.waiting(_uid)"}]},[_c('print-certificate',{attrs:{"certificate":_vm.certificate}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }